module.exports = __webpack_public_path__ + "img/icon.da25af4f.png";